/**
 * FilterIcon — PLP toolbar "Filter" glyph, vendored from the SFRA production
 * asset (`Sites-HSASTORE-Site/.../images/icon-filter.svg`, 24×23): three rules
 * with white "knob" cutouts.
 *
 * Inlined rather than hot-linked from the version-stamped demandware URL so it
 * renders identically on FSA/HSA/WDH and survives SFRA static redeploys (the
 * `vNNNNN` path changes each deploy). `stroke="currentColor"` lets it inherit
 * the toolbar trigger's `text-blue-04` (navy #142745). SFCC-11626.
 */
import { TOOLBAR_ICON_SIZE } from "./toolbar-trigger";

export function FilterIcon({ className }: { className?: string }) {
  return (
    <svg
      width={TOOLBAR_ICON_SIZE}
      // Preserve the asset's native 24×23 aspect ratio.
      height={(TOOLBAR_ICON_SIZE * 23) / 24}
      viewBox="0 0 24 23"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      aria-hidden="true"
      className={className}
    >
      <g transform="translate(1 1)">
        <line x1="0" y1="2.5" x2="22" y2="2.5" strokeLinecap="round" />
        <line x1="0" y1="10.5" x2="22" y2="10.5" strokeLinecap="round" />
        <line x1="0" y1="18.5" x2="22" y2="18.5" strokeLinecap="round" />
        <circle cx="7.5" cy="10.5" r="2.5" fill="#FFFFFF" />
        <circle cx="14.5" cy="18.5" r="2.5" fill="#FFFFFF" />
        <circle cx="14.5" cy="2.5" r="2.5" fill="#FFFFFF" />
      </g>
    </svg>
  );
}
